var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01277(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#010101;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,24C128.1,24,24,128.1,24,256c-0.1,44.6,12.8,88.3,37.1,125.7l-35.2,77.6c-4.6,10.2-0.2,22.2,10,26.8 c2.6,1.2,5.5,1.8,8.4,1.8c1.8,0,3.6-0.2,5.4-0.7l97.1-26.6c33.6,18,71.1,27.4,109.2,27.4c127.9,0,232-104.1,232-232 S383.9,24,256,24z M256,447.5L256,447.5c-33.9,0-67.1-9-96.4-26.1c-4.7-2.7-10.3-3.5-15.6-2l-63.4,17.4l22.1-48.7 c3-6.6,2.2-14.3-2-20.2C77.1,335.3,64.5,296.2,64.5,256c0-105.6,85.9-191.4,191.5-191.4S447.5,150.4,447.5,256 S361.6,447.5,256,447.5z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.2,290.7c-9.7-5.8-22.4-12.3-33.8-7.6c-8.8,3.6-14.4,17.3-20.1,24.3c-2.9,3.6-6.4,4.2-10.9,2.4 c-33-13.1-58.2-35.1-76.4-65.4c-3.1-4.7-2.5-8.4,1.2-12.8c5.5-6.5,12.4-13.8,13.9-22.5c1.5-8.7-2.6-18.9-6.2-26.7 c-4.6-9.9-9.8-24.1-19.7-29.7c-9.1-5.2-21.2-2.3-29.3,4.4c-14,11.4-20.8,29.3-20.6,47.1c0.1,5.1,0.7,10.1,1.9,15 c2.8,11.7,8.2,22.7,14.3,33.1c4.6,7.8,9.6,15.4,15,22.8c17.6,24.1,39.6,44.6,65,60.3c12.7,7.9,26.3,14.4,40.5,19.3 c15.9,5.2,30,10.7,47.2,7.5c17.9-3.4,35.6-14.5,42.8-31.8c2.1-5.1,3.2-10.8,2-16.2C369.4,302.8,354.2,296.1,345.2,290.7z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01277);
export default __webpack_public_path__ + "static/media/01-27-7.60b7e4d88696d03502c7ad5c83207bf3.svg";
export { ForwardRef as ReactComponent };